export default __webpack_public_path__ + "static/media/slidingafter.780b9c3c.jpg";